<template>
  <PanePromise
    id="fsdf33223f"
    ref="PanePromiseREF"
    fit-content
    disabled
  >
    <LayoutBase>
      <div class="calendar-container">
        <div class="header">
          <div class="header__mounth">
            {{ MOUNTH[currentMonth.month] }} {{ currentMonth.year }}
          </div>
          <div class="header__arrow">
            <div
              class="header__arrow-left"
              @click="prevMonth"
            >
              <img
                class="img"
                src="../assets/arrow.svg"
                alt=""
              >
            </div>
            <div
              class="header__arrow-right"
              @click="nextMonth"
            >
              <img
                class="img rotate"
                src="../assets/arrow.svg"
                alt=""
              >
            </div>
          </div>
        </div>
        <!-- {{ selectedDates }} -->
        <div class="week-days">
          <div
            v-for="item in WEEK_DAYS"
            :key="item"
            class="week-days-item"
          >
            {{ item }}
          </div>
        </div>
        <div class="days">
          <div
            v-for="day in currentMonth.days"
            :key="day.dayId"
            class="day"
            :class="{
              hideDay: day.otherMonth,
              selected: day.isSelected.value,
            }"
            @click="listeners.selectSingle(day)"
          >
            {{ day.date.getDate() }}
          </div>
        </div>
      </div>
      <ButtonBase
        :class="{ visible: selectedDates.length }"
        @click="select"
      >
        {{ t('common.next') }}
      </ButtonBase>
    </LayoutBase>
  </PanePromise>
</template>

<script setup>
import { ref } from "vue";
import { useCalendar } from "vue-use-calendar";
import { ButtonBase, PanePromise } from "@/UI";
import { LayoutBase } from '@/components/Layouts'
const PanePromiseREF = ref()

const emit = defineEmits(['choose'])

const WEEK_DAYS = ["ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ", "ВС"];
const MOUNTH = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Oктябрь",
  "Ноябрь",
  "Декабрь",
];

const MOUNTH_2 = [
  "Января",
  "Февраля",
  "Марта",
  "Апреля",
  "Мая",
  "Июня",
  "Июля",
  "Августа",
  "Сентября",
  "Oктября",
  "Ноября",
  "Декабря",
];

const { useMonthlyCalendar } = useCalendar({
  firstDayOfWeek: 1,
  startOn: new Date(),
});

const {
  nextMonth,
  prevMonth,
  currentMonth,
  selectedDates,
  listeners,
} = useMonthlyCalendar({ fullWeeks: true, infinite: true });

const select = () => {
  const date = selectedDates[0];

  const result = {
    title: `${date.getDate()} ${MOUNTH_2[date.getMonth()]
    } ${date.getFullYear()}`,
    date,
  };
  emit('choose', result)

  PanePromiseREF.value.close();
};

const openModal = () => {
  PanePromiseREF.value.open()
};

defineExpose({
  openModal,
});
</script>

<style scoped lang="scss">
.body--dark {
  .wrapper {
    background: #3e3e3e;
  }
}

.card {
  border-radius: 40px 40px 0px 0px;
  background: #f9fafd;
  border: 1px solid #edeffd;
  box-shadow: 0px -5px 10px rgba(0, 0, 0, 0.05);
}

.header {
  display: flex;
  justify-content: space-between;

  &__arrow {
    display: flex;
  }
}

.img {
  padding: 10px;

  &.rotate {
    transform: rotate(180deg);
  }
}

.btn {
  visibility: hidden;
  pointer-events: none;

  &.visible {
    visibility: visible;
    pointer-events: all;
  }
}

.wrapper {
  padding: 20px;
}

.calendar-container {
  padding: 30px;
}

.week-days {
  display: flex;
  justify-content: space-around;
}

.days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}

.day {
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1/1;

  &.selected {
    background: #4655c4;
    box-shadow: 0px 5px 20px rgba(70, 85, 196, 0.7);
    border-radius: 50%;
    color: #ffffff;
  }

  &.hideDay {
    visibility: hidden;
    pointer-events: none;
  }
}
</style>
